// The API stores a message export as "ChatEngineMessage" (what is sent and filtered on) and returns it
// as "Message", the way it returns "Lesson" as "Nutibite" (ExportDocumentSerializer, nutivate-api#128).
export const MESSAGE_EXPORT_TYPE = "ChatEngineMessage";
export const MESSAGE_EXPORT_RETURNED_TYPE = "Message";
